import React from 'react';
import AppleLoginButton from '~/components/LoginRegister/AppleLoginButton';
import EmailLoginButton from '~/components/LoginRegister/EmailLoginButton';
import FacebookLoginButton from '~/components/LoginRegister/FacebookLoginButton';
import GoogleSignInButton from '~/components/LoginRegister/GoogleSignInButton';
import { SocialAuthCallback } from '~/typings/services/iam/auth';

interface Props {
  emailCopy?: string;
  onSocialAuthNewUser?: SocialAuthCallback;
  onSocialAuthExistingEmail?: SocialAuthCallback;
  onClickEmail?: () => void;
  onSuccessfulLogin?: () => void;
}

/**
 * Contains all the social auth buttons.
 * onClickEmail is required if you want to show the Email Login button
 *
 * TODO: This component is named horribly
 */
const AuthButtons: React.FC<Props> = ({
  emailCopy = 'Continue with Email',
  onSocialAuthNewUser,
  onSocialAuthExistingEmail,
  onClickEmail,
  onSuccessfulLogin,
}) => (
  <div className="space-y-2">
    <FacebookLoginButton
      onSocialAuthExistingEmail={onSocialAuthExistingEmail}
      onSocialAuthNewUser={onSocialAuthNewUser}
      onSuccessfulLogin={onSuccessfulLogin}
    />

    <AppleLoginButton
      onSocialAuthExistingEmail={onSocialAuthExistingEmail}
      onSocialAuthNewUser={onSocialAuthNewUser}
      onSuccessfulLogin={onSuccessfulLogin}
    />

    <GoogleSignInButton
      onSocialAuthExistingEmail={onSocialAuthExistingEmail}
      onSocialAuthNewUser={onSocialAuthNewUser}
      onSuccessfulLogin={onSuccessfulLogin}
    />

    {onClickEmail && (
      <EmailLoginButton onClick={onClickEmail} text={emailCopy} />
    )}
  </div>
);

export default AuthButtons;
